/*
    © 2021 EcomGraduates.com
    https://www.ecomgraduates.com
*/

// Handle ajax 'Add To Cart' (ATC) forms
window.onSubmitAtcForm = async ($form, event) => {
    event.preventDefault()

    $form.classList.add('loading')

    const response = await fetch('/cart/add.js', { method: 'POST', body: new FormData($form) })
    const product = await response.json()

    $form.classList.remove('loading')

    if (document.querySelector('#modal-upsell-pdp')) {
        const modal = new bootstrap.Modal('#modal-upsell-pdp')
        console.log(modal)
        modal.show()
    } else {
        window.loadOffcanvasCart()
    }

    const quantity = Number($form.querySelector('[name="quantity"]')?.value || 1)

    window.ttq.track('AddToCart', {
        content_type: 'product',
        content_id: product.handle,
        content_name: product.title,
        quantity: quantity,
        price: product.price / 100,
        value: product.price / 100 * quantity,
        currency: 'USD'
    })
}

// Handle ajax 'Add To Cart' (ATC) form for the Modal upsell
window.onSubmitAtcFormModalUpsell = async ($form, event) => {
    event.preventDefault()

    $form.classList.add('loading')

    await fetch('/cart/add.js', { method: 'POST', body: new FormData($form) })

    $form.classList.remove('loading')

    const modal = bootstrap.Modal.getOrCreateInstance('#modal-upsell-pdp')
    modal.hide()

    window.loadOffcanvasCart()
}

// Offcanvas cart - load it on ajax add/update
window.loadOffcanvasCart = async () => {
    const offcanvasCart = document.querySelector('#offcanvas-cart')
    const bsOffcanvas = bootstrap.Offcanvas.getOrCreateInstance(offcanvasCart)
    const form = offcanvasCart.querySelector('form[action="/cart"]')
    const cartCountBadges = document.querySelectorAll('.cart-count-badge')

    form.classList.add('loading')

    if (!offcanvasCart.classList.contains('show')) {
        bsOffcanvas.show()
    }

    const respoonse = await fetch(window.location.href)
    const data = await respoonse.text()

    const parser = new DOMParser()
    const newDocument = parser.parseFromString(data, 'text/html')

    form.replaceWith(newDocument.querySelector('#offcanvas-cart form[action="/cart"]'))
    form.classList.remove('loading')

    cartCountBadges.forEach((badge) => {
        badge.style.display = 'block'
        badge.textContent = newDocument.querySelector('.cart-count-badge').textContent
    })

    initQuantityInputs()
    initRemoveButtons()
    initNoteInput()
    initCheckoutButton()
    initCartUpsellsAjaxATC()
    initCartGoal()
    initFreeProductOffer()

    if (!document.querySelector('#offcanvas-cart .product-list')) {
        cartCountBadges.forEach((badge) => {
            badge.style.display = 'none'
        })
        setTimeout(() => {
            bsOffcanvas.hide()
        }, 500)
    }
}

// Cart Note
const initNoteInput = () => {
    document.querySelectorAll('.btn-apply-note').forEach((btn) => {
        btn.addEventListener('click', async (e) => {
            btn.innerHTML = `
                <div 
                    class="spinner-border spinner-border-sm" 
                    role="status"
                    style="width: 1rem; height: 1rem">
                    <span class="visually-hidden">Loading...</span>
                </div>
            `
            const note = btn.previousElementSibling.value
            console.log(note)

            const response = await fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    note: note
                })
            })
            const data = await response.json()
            console.log(data)

            btn.innerHTML = '✓'

            setTimeout(() => {
                btn.innerHTML = btn.dataset.text
            }, 2000)
        })
    })
}
initNoteInput()

// Discount box
window.onClickApplyDiscountBtn = (btn, event) => {
    btn.innerHTML = `
        <div 
            class="spinner-border spinner-border-sm mx-2" 
            role="status"
            style="width: 1rem; height: 1rem">
            <span class="visually-hidden">Loading...</span>
        </div>
    `
    const discount = document.querySelector('#offcanvas-cart [name="discount"]').value
    window.location.href = `/checkout?discount=${discount}`
}

// Quantity inputs
const initQuantityInputs = () => {
    document.querySelectorAll('input[name="updates[]"]').forEach((input) => {
        input.addEventListener('change', async (e) => {
            await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    id: input.dataset.lineItemKey,
                    quantity: input.value
                })
            })
            if (document.body.classList.contains('request-page-type-cart')) {
                window.location.reload()
            } else {
                window.loadOffcanvasCart()
            }
        })
    })
}
initQuantityInputs()

// Remove buttons
const initRemoveButtons = () => {
    document.querySelectorAll('.btn-remove-line-item').forEach((btn) => {
        btn.addEventListener('click', async (e) => {
            await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    id: btn.dataset.lineItemKey,
                    quantity: 0
                })
            })
            window.loadOffcanvasCart()
        })
    })
}
initRemoveButtons()

// Checkout button - Indicate loading on click
const initCheckoutButton = () => {
    document.querySelectorAll('form[action="/cart"] .btn-checkout')
        .forEach((btn) => {
            btn.addEventListener('click', (e) => {
                btn.style.height = btn.clientHeight + 'px'
                btn.innerHTML = `
                    <div 
                        class="spinner-border spinner-border-sm" 
                        role="status"
                        style="width: 1.4rem; height: 1.4rem">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                `
            })
        })
}
initCheckoutButton()

// Cart upsells - handle ajax ATC
const initCartUpsellsAjaxATC = () => {
    document.querySelectorAll('#offcanvas-cart-upsells-list .btn-atc')
        .forEach((btn) => {
            btn.addEventListener('click', async (e) => {
                btn.style.height = btn.clientHeight + 'px'
                btn.innerHTML = `
                    <div 
                        class="spinner-border spinner-border-sm" 
                        role="status"
                        style="width: 1rem; height: 1rem">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                `
                const variantId = btn.closest('.product-list-item').querySelector('select[name="id"]').value
                await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        items: [{
                            id: Number(variantId),
                            quantity: 1
                        }]
                    })
                })
                window.loadOffcanvasCart()
            })
        })
}
initCartUpsellsAjaxATC()

// Cart Goal - Animate width
const initCartGoal = () => {
    const progressBar = document.querySelector('#cart-goal .progress-bar')
    if (progressBar) {
        setTimeout(() => {
            progressBar.style.width = progressBar.dataset.width
        }, 250)
    }
}
initCartGoal()

// Free product offer
const initFreeProductOffer = async () => {
    const isEnabled = window.cart_free_products && (window.cart_free_products.product_1_variant_id || window.cart_free_products.product_2_variant_id)

    if (!isEnabled) {
        return
    }

    const product1Id = window.cart_free_products.product_1_id
    const product1VariantId = window.cart_free_products.product_1_variant_id
    const product1Goal = window.cart_free_products.product_1_goal
    const product2Id = window.cart_free_products.product_2_id
    const product2VariantId = window.cart_free_products.product_2_variant_id
    const product2Goal = window.cart_free_products.product_2_goal

    const response = await fetch('/cart.json')
    const cart = await response.json()
    console.log(cart)

    const cartTotalPrice = cart.total_price
    const isProduct1InCart = cart.items.some(item => item.product_id === Number(product1Id))
    const isProduct2InCart = cart.items.some(item => item.product_id === Number(product2Id))

    if (product1VariantId && !isProduct1InCart && cartTotalPrice >= Number(product1Goal) * 100) {
        await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                items: [{
                    id: Number(product1VariantId),
                    quantity: 1
                }]
            })
        })
        window.loadOffcanvasCart()
    }

    if (product1VariantId && isProduct1InCart && cartTotalPrice < Number(product1Goal) * 100) {
        await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                id: product1VariantId.toString(),
                quantity: 0
            })
        })
        window.loadOffcanvasCart()
    }

    if (product2VariantId && !isProduct2InCart && cartTotalPrice >= Number(product2Goal) * 100) {
        await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                items: [{
                    id: Number(product2VariantId),
                    quantity: 1
                }]
            })
        })
        window.loadOffcanvasCart()
    }

    if (product2VariantId && isProduct2InCart && cartTotalPrice < Number(product2Goal) * 100) {
        await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                id: product2VariantId.toString(),
                quantity: 0
            })
        })
        window.loadOffcanvasCart()
    }
}

// Remove Free Products if the user decrease the cart total
// const removeFreeProductsHelper = async () => {
//     const isEnabled = window.cart_free_products && window.cart_free_products.product_1_variant_id

//     if (!isEnabled) {
//         return
//     }
// }

// Offcanvas cart - Open it if URL contains '#cart'
if (window.location.hash.includes('#cart')) {
    const offcanvasCart = bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-cart')
    offcanvasCart.show()
}

// Handle Variant change for free products
window.onChangeFreeProductInCart = async (select, event) => {
    await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            id: select.dataset.lineItemKey,
            quantity: 0
        })
    })
    await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            items: [{
                id: Number(select.value),
                quantity: 1
            }]
        })
    })
    window.loadOffcanvasCart()
}
